module.exports = __webpack_public_path__ + "img/cover-promotion-bg.3c42d41b.png";